$(window).on('load', function () {
    function loadHeaderFlightInformation() {
        var savedFlightNumber = $.cookie('userSavedFlight');

        if (savedFlightNumber != null) {
            jQuery.ajax({
                url: `/api/flights/flightarrivalsanddepartures?searchTerm=${savedFlightNumber}&exactflight=true`,
                type: 'GET',
                contentType: 'application/json; charset=utf-8',
                success: function(data) {
                    if (data.length > 0) {
                            loadBFlightBanner(data);
                    } else {
                        $('#ab-header-flight-info').empty();
                        $.removeCookie('userSavedFlight', { path: '/' });
                    }
                }
            });
        } else {
            $('#ab-header-flight-info').hide();
        }

        setTimeout(loadHeaderFlightInformation, 60000);
    }

    loadHeaderFlightInformation();
});

function loadRegularFlightBanner(data) {
    var $headerFlight = $('.header-flight');
    $headerFlight.hide();

    var flight = data[0];

    var template = $('#header-flight-info-template').html();
    Mustache.parse(template);

    var flightInfo = {
        'flightNumber': flight.flightNumber,
        'airlineLogo': flight.imgPath,
        'fromTo': flight.isArrival ? 'From' : 'To',
        'airport': flight.originalDestination,
        'departingArriving': flight.isArrival ? 'Arrive' : 'Depart',
        'scheduledTime': flight.localScheduledTimeForScript,
        'status': flight.message,
        'statusCssClass': flight.statusCssClass
    };

    var rendered = Mustache.render(template, flightInfo);
    $('#header-flight-info').html(rendered);
    setTimeout(function () { $headerFlight.show(); }, 0);
}

function loadBFlightBanner(data) {
    var $headerFlight = $('.ab-header-flight');
    $headerFlight.hide();

    var flight = data[0];

    var template = $('#AB-header-flight-info-template').html();
    Mustache.parse(template);

    var detailsUrl = '/flights/flight-detail?fltnmbr=' + flight.flightNumber;
    var flightInfo = {
        'flightNumber': flight.flightNumber,
        'airlineLogo': flight.imgPath,
        'fromTo': flight.isArrival ? 'From' : 'To',
        'airport': flight.originalDestination,
        'departingArriving': flight.isArrival ? 'Arrive' : 'Depart',
        'scheduledTime': flight.localScheduledTimeForScript,
        'status': flight.message,
        'statusCssClass': flight.statusCssClass,
        'detailsUrl': detailsUrl
    };

    var rendered = Mustache.render(template, flightInfo);
    $('#ab-header-flight-info').html(rendered);
    setTimeout(function () { $headerFlight.show(); }, 0);
}